<template>
  <div>
    <div class="title">{{ info.merchant_name }}</div>
    <div class="text">
      <a :href="'tel:' + info.phone" class="p tel">Tel: {{ info.phone }}</a>
      <div class="p">{{ info.address }}</div>
      <!-- <div class="p">邮箱：qdlanrensm@163.com</div> -->
      <!-- <div class="p">网址：http://aslr.93px.com</div> -->
    </div>
    <!-- <div class="map">
      <iframe src="https://aslra.shsfkjgs.com/map.html" width="100%" height="350px" frameborder="0"></iframe>
    </div> -->
  </div>
</template>
<script>
import { getMerInfo } from "@api/mendian";
export default {
  data() {
    return {
      info: ""
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo: function() {
      getMerInfo().then(res => {
        this.info = res.data;
      });
    }
  }
};
</script>
<style scoped>
.title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;
}
.text {
  font-size: 14px;
  padding: 15px;
}
.text .tel {
  font-weight: bold;
}
.text .p {
  margin-bottom: 5px;
}
.map {
  margin-top: 15px;
}
</style>
